export default () => ({
  dashboard: {},
  overview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  filters: {
    keyword: "",
    advanced: {
      title: null,
      currentlyWorking: [],
      iscoCode: null,
      completedCourses: [],
      route: [],
      trainingType: [],
      odysseaSupport: null,
      suitableJobs: [],
      projects: [],
      employmentStatus: [],
      branch: null,
      responsible: [],
      workSatisfaction: null,
      date: [],
    },
  },
});
